export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden bg-white">
      <div className="w-full px-6 md:px-10 lg:px-14 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8">
          <div className="w-full lg:w-[42%] text-center lg:text-left">
            <span className="inline-block text-sm font-medium text-[#4A90D9] border border-[#4A90D9]/30 rounded-full px-4 py-1.5 mb-6">
              Smart Document Scanner
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] font-bold text-gray-900 leading-tight tracking-tight">
              Scan, Edit &<br />
              Sign Your{" "}
              <span className="text-[#4A90D9]">PDFs</span>
            </h1>
            <p className="mt-5 md:mt-6 text-base md:text-lg text-gray-500 max-w-md mx-auto lg:mx-0 leading-relaxed">
              The all-in-one document scanner app. Auto-crop, enhance with
              AI filters, extract text with OCR, sign, watermark, and manage
              everything in one place.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="https://play.google.com/store/apps/details?id=com.forcekeys.scandoc.app"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#4A90D9] hover:bg-[#3A7BC8] text-white text-sm font-semibold px-7 py-3.5 rounded-full transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-google-play-fill text-base"></i>
                </span>
                Download on Google Play
              </a>
              <a
                href="/#features"
                className="inline-flex items-center gap-2 border-2 border-[#4A90D9] text-[#4A90D9] hover:bg-[#4A90D9]/5 text-sm font-semibold px-7 py-3 rounded-full transition-colors whitespace-nowrap"
              >
                Learn more
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[58%] flex items-center justify-center relative">
            <div className="relative flex items-center justify-center gap-3 md:gap-5">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20document%20scanner%20app%20UI%20screenshot%20on%20smartphone%20screen%20showing%20document%20scanning%20interface%20with%20clean%20minimal%20design%20light%20background%20professional%20product%20photography&width=300&height=600&seq=1&orientation=portrait"
                alt="ScanDoc app screenshot 1"
                className="w-28 sm:w-36 md:w-44 rounded-2xl shadow-xl object-cover hidden sm:block opacity-80 rotate-[-5deg] translate-y-4"
              />
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20document%20scanner%20app%20UI%20screenshot%20showing%20OCR%20text%20extraction%20interface%20with%20highlighted%20text%20on%20scanned%20document%20clean%20minimal%20design%20light%20background%20professional%20product%20photography&width=300&height=600&seq=2&orientation=portrait"
                alt="ScanDoc app screenshot 2"
                className="w-32 sm:w-40 md:w-52 rounded-2xl shadow-2xl object-cover z-10 rotate-[-2deg]"
              />
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20document%20scanner%20app%20UI%20screenshot%20showing%20PDF%20editor%20with%20signature%20and%20watermark%20tools%20clean%20minimal%20design%20light%20background%20professional%20product%20photography&width=300&height=600&seq=3&orientation=portrait"
                alt="ScanDoc app screenshot 3"
                className="w-28 sm:w-36 md:w-44 rounded-2xl shadow-xl object-cover hidden sm:block opacity-80 rotate-[5deg] translate-y-4"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}